import { render } from "./RegistrationModal.vue?vue&type=template&id=2abecb8b"
import script from "./RegistrationModal.vue?vue&type=script&lang=js"
export * from "./RegistrationModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__